<template>
  <div class="vertical-menu" >
    <VerticalMenuHeaderWidget :title="title || ''"/>
    <VerticalMenuBodyWidget :sidebar-menu="sidebarMenu"/>
  </div>
</template>
<script lang="ts">
import {defineComponent, type PropType} from 'vue';
import {VerticalMenuBodyWidget, VerticalMenuHeaderWidget} from '@shared/components/widgets';
import {type SidebarNs} from '@shared/types';

export default defineComponent({
  name: 'VerticalMenuTemplate',
  components: {
    VerticalMenuBodyWidget,
    VerticalMenuHeaderWidget,
  },
  props: {
    sidebarMenu: {
      type: Array as PropType<SidebarNs.SidebarMenu[]>,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
});
</script>
<style lang="scss" scoped>
.vertical-menu {
  position: fixed;
  top: var(--space-0);
  width: 300px;
  min-height: 100vh;
  padding: var(--space-16);
  background: var(--layout-sidebar-grey-bg);
  border-left: 1px solid var(--border-neutral);
  border-right: 1px solid var(--border-neutral);
  z-index: 1;

  h3 {
    margin-top: var(--space-16);
  }
}
</style>
